import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Clock, IndianRupee } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent, CardFooter } from './ui/card';

export const TourCard = ({ tour }) => {
  return (
    <Card className="overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
      <Link to={`/tour/${tour.id}`}>
        <div className="relative h-56 overflow-hidden">
          <img
            src={tour.image}
            alt={tour.title}
            className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
          />
          <div className="absolute top-4 right-4 bg-white px-3 py-1 rounded-full shadow-md">
            <span className="text-sky-600 font-bold flex items-center">
              <IndianRupee className="w-4 h-4" />
              {tour.price.replace('₹', '')}
            </span>
          </div>
        </div>
      </Link>
      
      <CardContent className="p-5">
        <Link to={`/tour/${tour.id}`}>
          <h3 className="text-xl font-bold text-gray-800 mb-2 hover:text-sky-600 transition-colors">
            {tour.title}
          </h3>
        </Link>
        
        <div className="flex items-center text-gray-600 mb-2">
          <MapPin className="w-4 h-4 mr-2 text-sky-600" />
          <span className="text-sm">{tour.destination}</span>
        </div>
        
        <div className="flex items-center text-gray-600 mb-3">
          <Clock className="w-4 h-4 mr-2 text-emerald-600" />
          <span className="text-sm">{tour.duration}</span>
        </div>
        
        <p className="text-gray-600 text-sm line-clamp-2">{tour.description}</p>
      </CardContent>
      
      <CardFooter className="p-5 pt-0">
        <Link to={`/tour/${tour.id}`} className="w-full">
          <Button className="w-full bg-gradient-to-r from-sky-500 to-emerald-500 hover:from-sky-600 hover:to-emerald-600 text-white">
            View Details
          </Button>
        </Link>
      </CardFooter>
    </Card>
  );
};